import styled from 'styled-components';
import {
  Flex,
  icons,
} from 'web-styled';

export const UserStats = styled(Flex)`
  color: white;
`;


export const Stat = styled(Flex).attrs({
  column: true,
  align: 'center',
})`
`;

export const StatTitle = styled(Flex)`
  border-bottom: 1px solid #fff;
  padding: 0 5px;
  color: #fff;
  font-size: 13px;
  padding-bottom: 5px;
`;
export const StatValue = styled(Flex)`
  color: #fff;
  font-size: 13px;
  padding-top: 5px;
  text-transform: uppercase;
`;

export const Header = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})`
  background: ${props => props.theme.colors.baseBanner};
  width: 100%;
  color: white;
  height: 80px;
  padding: 20px 25px;
  flex-shrink: 0;
`;
